import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=093cd236&scoped=true&lang=pug&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=093cd236&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093cd236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('093cd236', component.options)
    } else {
      api.reload('093cd236', component.options)
    }
    module.hot.accept("./nav.vue?vue&type=template&id=093cd236&scoped=true&lang=pug&", function () {
      api.rerender('093cd236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project_editor/component/nav.vue"
export default component.exports